(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mt-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mt-scope .faq-item').forEach(function (it) {
  var q = it.querySelector('.faq-q'), a = it.querySelector('.faq-a');
  if (!q || !a) return;
  q.addEventListener('click', function () {
    var open = it.classList.contains('open');
    it.closest('.mt-scope').querySelectorAll('.faq-item.open').forEach(function (o) {
      o.classList.remove('open');
      o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      o.querySelector('.faq-a').style.maxHeight = null;
    });
    if (!open) {
      it.classList.add('open');
      q.setAttribute('aria-expanded', 'true');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mt-scope .mt-pfaq-sec .faq-item').forEach(function (it) {
  var q = it.querySelector('.faq-q'), a = it.querySelector('.faq-a');
  if (!q || !a) return;
  q.addEventListener('click', function () {
    var open = it.classList.contains('open');
    it.closest('.mt-pfaq-sec').querySelectorAll('.faq-item.open').forEach(function (o) {
      o.classList.remove('open');
      o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      o.querySelector('.faq-a').style.maxHeight = null;
    });
    if (!open) {
      it.classList.add('open');
      q.setAttribute('aria-expanded', 'true');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mt-scope[data-mt-pdp]').forEach(function (root) {
    // Gallery thumb swap
    var main = root.querySelector('.gallery-main img');
    root.querySelectorAll('.gthumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.gthumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (main && t.dataset.full) main.src = t.dataset.full;
      });
    });
    // Add-on selection + displayed total (visual)
    var totalEl = root.querySelector('[id^="mtTotal-"]');
    var stickyEl = root.querySelector('[id^="mtStickyTotal-"]');
    var base = totalEl ? parseInt(totalEl.dataset.base, 10) || 0 : 0;
    function fmt(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
    function recalc() {
      var t = base;
      root.querySelectorAll('.addon.on').forEach(function (a) { t += parseInt(a.dataset.price, 10) || 0; });
      if (totalEl) totalEl.textContent = fmt(t);
      if (stickyEl) stickyEl.textContent = fmt(t);
    }
    root.querySelectorAll('.addon').forEach(function (a) {
      function toggle() {
        var on = a.classList.toggle('on');
        a.setAttribute('aria-pressed', on ? 'true' : 'false');
        recalc();
      }
      a.addEventListener('click', toggle);
      a.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    // Form-free variant selection: clicking an option finds the matching variant
    // and updates the hidden id + the displayed price.
    var vui = root.querySelector('[data-mt-variants-ui]');
    if (vui) {
      var variants = [];
      try { variants = JSON.parse(vui.querySelector('[data-mt-variants-json]').textContent); } catch (e) {}
      var vIdInput = root.querySelector('[data-mt-id]');
      var amtEl = root.querySelector('.pdp-price .amt');
      var vBuyBtn = root.querySelector('[data-mt-add]');
      var vfmt = function (cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); };
      var syncVariant = function () {
        var sel = [];
        vui.querySelectorAll('.mt-vopt').forEach(function (grp) {
          var on = grp.querySelector('.mt-vbtn.on');
          sel.push(on ? on.dataset.optValue : null);
        });
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < sel.length; j++) { if (sel[j] !== null && variants[i].options[j] !== sel[j]) { ok = false; break; } }
          if (ok) { match = variants[i]; break; }
        }
        if (!match) return;
        if (vIdInput) vIdInput.value = match.id;
        if (amtEl) amtEl.textContent = vfmt(match.price);
        if (vBuyBtn) {
          if (match.available === false) { vBuyBtn.setAttribute('disabled', ''); }
          else { vBuyBtn.removeAttribute('disabled'); }
        }
        // Keep the package total in sync with the selected variant's price.
        base = match.price;
        recalc();
      };
      vui.querySelectorAll('.mt-vbtn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.closest('.mt-vopt').querySelectorAll('.mt-vbtn').forEach(function (b) { b.classList.remove('on'); });
          btn.classList.add('on');
          syncVariant();
        });
      });
      syncVariant();
    }

    // Add to cart entirely in JS — there is no <form>, so a native or rogue
    // form.submit() can never navigate to /cart/add. The button adds the main
    // product + any checked add-ons via /cart/add.js, then goes to the cart.
    var buybox = root.querySelector('[data-mt-buybox]');
    var addBtn = root.querySelector('[data-mt-add]');
    var busy = false;
    if (buybox && addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return;
        var idInput = buybox.querySelector('[data-mt-id]') || buybox.querySelector('[name="id"]');
        var mainId = idInput && idInput.value;
        if (!mainId) return;
        var props = {};
        buybox.querySelectorAll('[name^="properties["]').forEach(function (inp) {
          var m = inp.name.match(/properties\[(.+)\]/);
          if (m && inp.value) props[m[1]] = inp.value;
        });
        var items = [{ id: mainId, quantity: 1 }];
        if (Object.keys(props).length) items[0].properties = props;
        root.querySelectorAll('.addon.on').forEach(function (a) {
          if (a.dataset.variantId) items.push({ id: a.dataset.variantId, quantity: 1 });
        });
        var errWrap = root.querySelector('.product-form__error-message-wrapper');
        if (errWrap) errWrap.hidden = true;
        busy = true;
        addBtn.setAttribute('aria-disabled', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw d; });
          return r.json();
        }).then(function () {
          window.location.href = root.dataset.cartUrl || '/cart';
        }).catch(function (err) {
          busy = false;
          addBtn.removeAttribute('aria-disabled');
          if (errWrap) {
            errWrap.hidden = false;
            var msg = errWrap.querySelector('.product-form__error-message');
            if (msg) msg.textContent = (err && err.description) || 'Could not add to cart. Please try again.';
          }
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
